export default __webpack_public_path__ + "static/8_20-faf4b7798f86e06a386745efbdd10b30.png";